import React from 'react';
import PropTypes from 'prop-types';

function RightArrowIcon({ color = 'black', width = 8, height = 14, ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 8 14"
      fill="none"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.17266 6.99974L0.222656 2.04974L1.63666 0.635742L8.00066 6.99974L1.63666 13.3637L0.222656 11.9497L5.17266 6.99974Z"
        fill={color}
        fillOpacity="0.52"
      />
    </svg>
  );
}

RightArrowIcon.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number
};

export default RightArrowIcon;
